import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { SapBdcLinkedService } from 'app/model/linkedservice/sap-bdc.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapBdcLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*'
        }
    }
})
export class SapBdcLinkedServiceAdapter extends LinkedServiceAdapter<SapBdcLinkedService> {
    protected modelConstructor(): new () => SapBdcLinkedService {
        return SapBdcLinkedService;
    }

    protected model(): IModel {
        return SapBdcLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SapBdcLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SapBdcLinkedService): Promise<SapBdcLinkedService> {
        return linkedService;
    }
}
